export class ConnectionData {
    State: string;
    Timestamp: number;
    FormattedTimeStamp: string;
    IsConnected: boolean;
    ClientInitiatedDisconnect: boolean;
}
